import { gql } from "@apollo/client";


export const GET_STANDARD_DECISIONS = gql`
    query GetStandardDecisions($standardId: ID!, $ideaId: ID!, $userId: ID!) {
        getStandardDecisions(standardId: $standardId, ideaId: $ideaId, userId: $userId) {
            id
            step
            question
            help
            options {
                id
                option
                nextDecision
                chosen
            }
        }
    }
`;

export const GET_EVALUATION_TEST_SET_FOR_SELECTED_OPTIONS = gql`
    query GetEvaluationTestSetForSelectedOptions($optionIds: String!) {
        getEvaluationTests(optionIds: $optionIds) {
            name
        }
    }
`;
